module.exports = __webpack_public_path__ + "static/home-depot-afd18c635d20080e5a49bf9bf62783c7.png";